/**
 * Id único por INSTÂNCIA de componente.
 *
 * Para que serve
 * --------------
 * `<label for>` só liga o rótulo ao campo se o `for` apontar para o `id` daquele campo. Um
 * id ESTÁTICO dentro de um componente quebra essa ligação assim que o componente aparece
 * duas vezes na mesma tela: os dois rótulos passam a apontar para o mesmo id, o navegador
 * resolve para o PRIMEIRO campo, e clicar no segundo rótulo foca o campo errado — além de
 * o leitor de tela anunciar o mesmo nome para dois campos diferentes
 * (WCAG 1.3.1 / 3.3.2 / 4.1.2).
 *
 * O contador é de MÓDULO, e não por componente, para que dois componentes diferentes
 * também nunca colidam entre si.
 *
 * Por que existe além do `novoIdTitulo` de `dialogo-acessivel.ts`: aquele é específico do
 * título de diálogo e vive junto do resto da mecânica de diálogo. Este é o caso geral de
 * campo de formulário, e deixá-lo aqui evita que componentes de formulário passem a
 * importar o utilitário de diálogo só para gerar um id.
 *
 * Uso típico:
 *
 *     import { novoId } from '@/uteis/id-unico';
 *     data() { return { idCampo: novoId('ddl-parentesco') }; }
 *
 *     <label :for="idCampo">Parentesco</label>
 *     <select :id="idCampo">…</select>
 */
let sequencial = 0;

export function novoId(prefixo = 'campo'): string {
  sequencial += 1;
  return `${prefixo}-${sequencial}`;
}

export default { novoId };
